import React from "react";
import { Box, Grid, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { fadeUp, revealProps, stagger, useReducedMotion } from "homepage-new/motion";
import { rf } from "../theme";
import { Band, Card, Display } from "../ui";

const FILLS = [rf.amber, rf.sky, rf.mint, rf.lilac];

const initials = (name) =>
  name
    .split(" ")
    .map((w) => w[0])
    .slice(0, 2)
    .join("");

export const Instructors = ({ instructors = [] }) => {
  const reduced = useReducedMotion();
  if (instructors.length === 0) return null;

  return (
    <Band
      id="who-teaches"
      eyebrow="Who teaches"
      title="The person in the room builds this for a living"
      lead="Not a teaching assistant reading someone else's deck. The people below take the classes themselves, and review the code you write."
    >
      <motion.div variants={stagger(0.08)} {...revealProps(reduced)}>
        <Grid container spacing={3} justifyContent="center">
          {instructors.map((person, i) => (
            <Grid item xs={12} sm={6} md={5} key={person.id}>
              <motion.div variants={fadeUp} style={{ height: "100%" }}>
                <Card sx={{ p: 3.25, height: "100%", textAlign: "left", display: "flex", gap: 2.5 }}>
                  <Box
                    aria-hidden="true"
                    sx={{
                      width: 60,
                      height: 60,
                      flexShrink: 0,
                      borderRadius: rf.radiusSm,
                      display: "grid",
                      placeItems: "center",
                      backgroundColor: FILLS[i % FILLS.length],
                      border: rf.line,
                      boxShadow: rf.shadowSm,
                      fontFamily: rf.display,
                      fontWeight: 800,
                      fontSize: 20,
                      color: rf.ink,
                    }}
                  >
                    {initials(person.name)}
                  </Box>
                  <Box>
                    <Display component="h3" size={21}>
                      {person.name}
                    </Display>
                    <Typography sx={{ fontFamily: rf.display, fontSize: 14, fontWeight: 700, color: rf.coralDeep, mb: 1 }}>
                      {person.role}
                    </Typography>
                    <Typography sx={{ fontFamily: rf.body, fontSize: 14.5, color: rf.inkSoft, lineHeight: 1.6 }}>
                      {person.bio}
                    </Typography>
                  </Box>
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </motion.div>
    </Band>
  );
};

export default Instructors;
